import styles from './DotDivider.module.scss';

const DotDivider = ({dots=8}) => {
    return ( 
        <div className={styles.dotDivider}>
            <div>
                {Array(dots).fill().map((dot, i)=>
                <div className={styles.dotDivider__dot} key={i}></div>
                )}
            </div>
        </div>
     );
}
 
export default DotDivider;